import fetchData from "../utils/HttpClient";
import {IndexResponseInterface} from "../interfaces/core/IndexResponseInterface";

export function getIndex(): Promise<IndexResponseInterface> {
    return fetchData('/api/index')
}